export class MapperCompute {
    constructor(
        public readonly coreCount: number,
        public readonly computeType: string){
    }
}
